import { Component, OnInit, inject } from '@angular/core';
import { ModalContent, ModalRef } from '../../../modal-ref';
import { LoyaltyStatusData } from '../../../../services/user/user-comp-points.service';
import { UserService } from '../../../../services/user/user.service';
import { LanguageService } from '../../../../services/language.service';
import { SafePipe } from 'ngx-unificator/pipes';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { RouterLinkDirective } from '../../../../shared/directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { BtnComponent } from '../../../../shared/components/btn/btn.component';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-loyalty-bonus-modal',
    templateUrl: './loyalty-bonus-modal.component.html',
    styleUrls: ['./loyalty-bonus-modal.component.scss'],
    imports: [BtnComponent, RouterLink, RouterLinkDirective, DecimalPipe, TranslatePipe, SafePipe]
})
export class LoyaltyBonusModalComponent implements OnInit, ModalContent {
  user = inject(UserService);
  lang = inject(LanguageService);


  public modal: ModalRef;

  ngOnInit(): void {
  }

  get data(): LoyaltyStatusData {
    return this.modal.options.data;
  }

}
